(function () {
    "use strict";

    // @ngInject
    function WorkspaceTasksControllerCtor($scope, $stateParams, $injector) {

        var self = this;

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkspaceTasksController';

        this.workspaceId = $stateParams.workspace_id;
    }


    Controllers.WorkspaceTasksController = Class(Controllers.BaseController, {

        constructor: WorkspaceTasksControllerCtor
    });
}());
